import React from 'react'
import { CgClose } from "react-icons/cg";

const Alert = ({ extraclass, maxWidth, minHeight, title, body, bottom, onClose }: { 
  extraclass?: string,
  maxWidth?: number, 
  minHeight?: number,
  title?: React.ReactNode, 
  body?: React.ReactNode, 
  bottom?: React.ReactNode,
  onClose?: () => void
}) => {
  return (
    <div className={'bg-white flex flex-col rounded-xl shadow-lg w-full overflow-auto ' + extraclass} style={{ maxWidth: maxWidth, minHeight: minHeight, maxHeight: '80vh' }}>
      <div className='p-4 sticky top-0 flex items-center justify-center'>
        <div className='text-lg'>{title}</div>
        <button onClick={onClose} className='hover:bg-gray-100 absolute left-4 w-8 h-8 rounded-full flex items-center justify-center'><CgClose className='text-xl' /></button>
      </div>
      <div className='px-4 my-4 w-full overflow-auto flex-1'>
        {body}
      </div>
      <div className='p-4 sticky bottom-0'>
        {bottom}
      </div>
    </div>
  )
}

export default Alert